import { render, staticRenderFns } from "./TransferenciaDesdobramento.vue?vue&type=template&id=f91906ae&lang=html&"
import script from "./TransferenciaDesdobramento.vue?vue&type=script&lang=js&"
export * from "./TransferenciaDesdobramento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/custom/abbrasil/spa/orcamento/transferencia/TransferenciaDesdobramento.vue
// module id = 1556
// module chunks = 28